import React from "react";

// Golf Power Play Logo - playing card with golf ball + lightning power motif
export const LogoMark = ({ className = "", size = 36, color = "currentColor" }) => (
    <svg
        viewBox="0 0 128 128"
        width={size}
        height={size}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-label="Golf Power Play"
        role="img"
    >
        {/* Card outline */}
        <rect
            x="18"
            y="8"
            width="92"
            height="112"
            rx="16"
            stroke={color}
            strokeWidth="6"
            fill="none"
        />
        {/* Corner indices */}
        <text
            x="30"
            y="34"
            fontFamily="Manrope, sans-serif"
            fontSize="16"
            fontWeight="800"
            fill={color}
        >
            G
        </text>
        <text
            x="86"
            y="108"
            fontFamily="Manrope, sans-serif"
            fontSize="16"
            fontWeight="800"
            fill={color}
        >
            P
        </text>

        {/* Golf ball */}
        <circle
            cx="64"
            cy="58"
            r="20"
            stroke={color}
            strokeWidth="5"
            fill="none"
        />
        {/* dimples */}
        <circle cx="58" cy="52" r="1.6" fill={color} />
        <circle cx="70" cy="52" r="1.6" fill={color} />
        <circle cx="64" cy="58" r="1.6" fill={color} />
        <circle cx="58" cy="64" r="1.6" fill={color} />
        <circle cx="70" cy="64" r="1.6" fill={color} />

        {/* Lightning bolt below ball */}
        <path
            d="M66 82 L54 102 L62 102 L58 116 L74 96 L66 96 L70 82 Z"
            fill={color}
            stroke={color}
            strokeWidth="1"
            strokeLinejoin="round"
        />
    </svg>
);

export const LogoLockup = ({ size = 36, className = "" }) => (
    <div
        className={`flex items-center gap-2.5 ${className}`}
        data-testid="brand-logo"
    >
        <span className="inline-flex items-center justify-center rounded-xl bg-[hsl(var(--primary))] p-1.5 shadow-[0_8px_24px_rgba(6,42,30,0.18)]">
            <LogoMark size={size - 8} color="#FBF7EE" />
        </span>
        <div className="leading-none">
            <div className="font-logo text-[1.05rem] sm:text-[1.15rem] font-medium text-[#062A1E]">
                GOLF <span className="text-[#C8A24A]">POWER</span> PLAY
                <sup className="text-[0.55em] font-semibold text-[#5B6B63] ml-0.5 align-super">™</sup>
            </div>
            <div className="font-medium text-[10px] tracking-[0.18em] uppercase text-[#5B6B63] mt-0.5">
                The Card Game · Reimagined
            </div>
        </div>
    </div>
);

export default LogoLockup;
